import { render } from "./CacheStatistics.vue?vue&type=template&id=f4806da0"
import script from "./CacheStatistics.vue?vue&type=script&lang=js"
export * from "./CacheStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__